export var IdPurchaseOfferGroup;
(function (IdPurchaseOfferGroup) {
    IdPurchaseOfferGroup[IdPurchaseOfferGroup["Sms"] = 122] = "Sms";
})(IdPurchaseOfferGroup || (IdPurchaseOfferGroup = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdPurchaseOfferGroup.ts
// module id = 833
// module chunks = 3